
require('./scss/vendor/vendor.scss');
require('./../node_modules/@glidejs/glide/src/assets/sass/glide.core.scss');
let ctx = require.context('./js/vendor', false, /\.ts|js$/);
ctx.keys().forEach(ctx);